export const DisablePageScroll = (): void => {
  document.body.classList.add('modal-open');
};

export const EnablePageScroll = (): void => {
  document.body.classList.remove('modal-open');
};
